const mobileDrawerMedia = window.matchMedia('(max-width: 749px)');

const mobileMenuStyles = `
@media screen and (max-width: 749px) {
  .blm-mobile-original-navigation { display: none !important; }
  .blm-mobile-custom-shell { width: 100%; flex: 0 0 auto; }
  .blm-mobile-custom-nav,
  .blm-mobile-service-nav { width: 100%; padding-inline: var(--drawer-padding); }
  .blm-mobile-custom-row,
  .blm-mobile-custom-group {
    display: block;
    width: 100%;
    border-bottom: 1px solid rgb(var(--color-foreground-rgb) / 11%);
  }
  .blm-mobile-custom-link,
  .blm-mobile-custom-summary {
    display: flex;
    width: 100%;
    min-height: 58px;
    align-items: center;
    justify-content: space-between;
    padding: 14px 0;
    color: inherit;
    font-family: var(--menu-top-level-font-family);
    font-size: clamp(1rem, 4.25vw, 1.15rem);
    font-style: var(--menu-top-level-font-style);
    font-weight: var(--menu-top-level-font-weight);
    line-height: 1.2;
    letter-spacing: 0.015em;
    text-decoration: none;
  }
  .blm-mobile-custom-summary { cursor: pointer; list-style: none; }
  .blm-mobile-custom-summary::-webkit-details-marker { display: none; }
  .blm-mobile-custom-symbol {
    display: grid;
    width: 32px;
    height: 32px;
    place-items: center;
    flex: 0 0 auto;
    font-size: 1.35rem;
    font-weight: 300;
    line-height: 1;
  }
  .blm-mobile-custom-submenu { margin: 0; padding: 0 0 13px 14px; }
  .blm-mobile-custom-sublink {
    display: block;
    min-height: 42px;
    padding: 10px 0;
    color: inherit;
    font-size: 0.92rem;
    line-height: 1.35;
    text-decoration: none;
  }
  .blm-mobile-service-nav {
    margin-top: 12px;
    padding-top: 0;
    padding-bottom: 18px;
    border-top: 0 !important;
  }
  .blm-mobile-service-link {
    display: block;
    min-height: 46px;
    padding: 12px 0;
    color: inherit;
    font-size: 0.9rem;
    letter-spacing: 0.055em;
    text-decoration: none;
  }
  .blm-mobile-service-link--icon {
    display: flex;
    align-items: center;
    gap: 11px;
  }
  .blm-mobile-service-link__icon {
    display: inline-flex;
    width: 18px;
    height: 18px;
    flex: 0 0 auto;
    color: inherit;
  }
  .blm-mobile-service-link__icon svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
  }
  .blm-mobile-menu-products {
    width: 100%;
    flex: 0 0 auto;
    margin-top: 10px;
    padding-block: 22px 24px;
    border-top: 1px solid rgb(var(--color-foreground-rgb) / 12%);
    background: rgb(var(--color-foreground-rgb) / 2.5%);
  }
  .blm-mobile-menu-products__title {
    margin: 0;
    padding-inline: var(--padding-xl);
    font-family: var(--font-heading--family);
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
  .blm-mobile-menu-products .menu-drawer__featured-content-list {
    gap: 12px;
    margin-block: 16px 0;
    padding-block-end: 0;
    scroll-snap-type: x proximity;
  }
  .blm-mobile-menu-products .menu-drawer__featured-content-list-item--product {
    width: min(64vw, 260px) !important;
    scroll-snap-align: start;
  }
  .blm-mobile-bottom-dock {
    position: sticky;
    bottom: 0;
    z-index: 2;
    display: flex;
    width: 100%;
    min-height: 66px;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-top: auto;
    padding: 10px max(var(--padding-xl), env(safe-area-inset-right)) max(10px, env(safe-area-inset-bottom)) max(var(--padding-xl), env(safe-area-inset-left));
    border-top: 1px solid rgb(var(--color-foreground-rgb) / 14%);
    background: var(--color-background, #fff);
  }
  /* Requested removal of the entrance/slide-in animation on the sticky
     account + currency row — this dock (and everything in it, including
     the localization utility-links element moved in from the native
     drawer, which may carry the native staggered-reveal animation class)
     now renders instantly in its final state, no animate-in. */
  .blm-mobile-bottom-dock,
  .blm-mobile-bottom-dock * {
    animation: none !important;
    opacity: 1 !important;
    transform: none !important;
  }
  .blm-mobile-account-link {
    display: inline-flex;
    min-width: 48px;
    min-height: 44px;
    align-items: center;
    gap: 9px;
    color: inherit;
    font-size: 0.86rem;
    text-decoration: none;
  }
  .blm-mobile-account-link svg { width: 23px !important; height: 23px !important; }
  .blm-mobile-currency-slot {
    display: flex;
    min-width: 72px;
    min-height: 44px;
    align-items: center;
    justify-content: flex-end;
  }
  .blm-mobile-currency-slot .menu-drawer__utility-links {
    display: flex !important;
    align-items: flex-end;
    margin: 0 !important;
    padding: 0 !important;
  }
  .blm-mobile-currency-slot .drawer-localization__button,
  .blm-mobile-currency-slot .localization-form__select { min-height: 44px; }
  .blm-mobile-currency-fallback { font-size: 0.82rem; letter-spacing: 0.04em; }
}`;

function installMobileMenuStyles() {
  if (document.getElementById('blm-mobile-menu-redesign-styles')) return;
  const style = document.createElement('style');
  style.id = 'blm-mobile-menu-redesign-styles';
  style.textContent = mobileMenuStyles;
  document.head.append(style);
}

const mobileMenu = [
  { title: 'SHOP THE SEASON', url: '/collections/all?sort_by=created-descending' },
  {
    title: 'BOUQUETS',
    items: [
      ['All Bouquets', '/collections/bouquets'],
      ['Signature Botanicals', '/collections/all'],
      ['Grand Arrangements', '/search?q=grand&type=product'],
    ],
  },
  {
    title: 'STEMS & BRANCHES',
    items: [
      ['All Stems', '/collections/stems'],
      ['Branches', '/search?q=branches&type=product'],
      ['Leaves', '/search?q=leaves&type=product'],
    ],
  },
  {
    title: 'MOST POPULAR',
    items: [
      ['Best Sellers', '/collections/all?sort_by=best-selling'],
      ['The Classics', '/collections/all?sort_by=best-selling'],
      ['New Arrivals', '/collections/all?sort_by=created-descending'],
    ],
  },
  {
    title: 'COLLECTIONS',
    items: [
      ['All Collections', '/collections'],
      ['White Botanicals', '/search?q=white&type=product'],
      ['Peonies', '/search?q=peony&type=product'],
      ['Statement Arrangements', '/search?q=grand&type=product'],
    ],
  },
  {
    title: 'VASES',
    items: [
      ['All Vases', '/search?q=vase&type=product'],
      ['Styling Guide', '/pages/styling-guide'],
      ['Care Guide', '/pages/care-guide'],
    ],
  },
];

// Reverted to ALL CAPS to match the other service links.
const serviceMenu = [
  ['TRACK ORDER', '/a/track-order'],
  ['ABOUT', '/pages/about'],
  ['CONTACT', '/pages/contact'],
];

// Exact native Shopify Horizon 'heart' icon path, copied verbatim from
// snippets/icon.liquid (the same source the 'icon' block and product-page
// icon rendering use) so this is pixel-identical to any other heart icon
// already in the theme, not a redrawn approximation.
const heartIconSvg =
  '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 5.2393L8.5149 3.77392C6.79996 2.08174 4.01945 2.08174 2.30451 3.77392C0.589562 5.4661 0.589563 8.2097 2.30451 9.90188L10 17.4952L17.6955 9.90188C19.4104 8.2097 19.4104 5.4661 17.6955 3.77392C15.9805 2.08174 13.2 2.08174 11.4851 3.77392L10 5.2393ZM10.765 3.06343C12.8777 0.978857 16.3029 0.978856 18.4155 3.06343C20.5282 5.148 20.5282 8.52779 18.4155 10.6124L10.72 18.2057C10.3224 18.5981 9.67763 18.5981 9.27996 18.2057L1.58446 10.6124C-0.528154 8.52779 -0.528154 5.14801 1.58446 3.06343C3.69708 0.978859 7.12233 0.978858 9.23495 3.06343L10 3.81832L10.765 3.06343Z" fill-rule="evenodd"/></svg>';

const rulerIconSvg =
  '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M18.9836 5.32852L14.6715 1.01638L1.01638 14.6715L5.32852 18.9836L18.9836 5.32852ZM15.3902 0.297691C14.9933 -0.0992303 14.3497 -0.0992303 13.9528 0.297691L0.297691 13.9528C-0.0992301 14.3497 -0.0992305 14.9932 0.297691 15.3902L4.60983 19.7023C5.00675 20.0992 5.65029 20.0992 6.04721 19.7023L19.7023 6.04721C20.0992 5.65029 20.0992 5.00675 19.7023 4.60983L15.3902 0.297691Z" fill-rule="evenodd"/><path d="M11.7863 2.67056C11.9848 2.4721 12.3065 2.4721 12.505 2.67056L14.4237 4.58927C14.6222 4.78774 14.6222 5.1095 14.4237 5.30796C14.2252 5.50642 13.9035 5.50642 13.705 5.30796L11.7863 3.38925C11.5878 3.19079 11.5878 2.86902 11.7863 2.67056Z"/><path d="M8.93891 5.36331C9.13737 5.16485 9.45914 5.16485 9.6576 5.36331L11.5763 7.28202C11.7748 7.48048 11.7748 7.80225 11.5763 8.00071C11.3779 8.19917 11.0561 8.19917 10.8576 8.00071L8.93891 6.082C8.74045 5.88354 8.74045 5.56177 8.93891 5.36331Z"/><path d="M6.24307 8.20742C6.44153 8.00896 6.76329 8.00896 6.96175 8.20742L8.88047 10.1261C9.07893 10.3246 9.07893 10.6464 8.88047 10.8448C8.68201 11.0433 8.36024 11.0433 8.16178 10.8448L6.24307 8.92611C6.0446 8.72765 6.0446 8.40588 6.24307 8.20742Z"/><path d="M3.37296 10.8776C3.57142 10.6791 3.89319 10.6791 4.09165 10.8776L6.01036 12.7963C6.20882 12.9948 6.20882 13.3165 6.01036 13.515C5.8119 13.7134 5.49013 13.7134 5.29167 13.515L3.37296 11.5963C3.1745 11.3978 3.1745 11.076 3.37296 10.8776Z"/></svg>';

const serviceMenuIconLinks = [
  ['WISHLIST', '/pages/wishlist', heartIconSvg],
  ['STYLE GUIDE', '/pages/styling-guide', rulerIconSvg],
];

function createLink(label, url, className) {
  const link = document.createElement('a');
  link.href = url;
  link.className = className;
  link.textContent = label;
  return link;
}

function createIconLink(label, url, iconSvg, className) {
  const link = document.createElement('a');
  link.href = url;
  link.className = className;
  const iconSpan = document.createElement('span');
  iconSpan.className = 'blm-mobile-service-link__icon';
  iconSpan.setAttribute('aria-hidden', 'true');
  iconSpan.innerHTML = iconSvg;
  const labelSpan = document.createElement('span');
  labelSpan.textContent = label;
  link.append(iconSpan, labelSpan);
  return link;
}

function createMenuGroup(group) {
  if (!group.items) {
    const row = document.createElement('div');
    row.className = 'blm-mobile-custom-row blm-mobile-custom-row--season';
    row.append(createLink(group.title, group.url, 'blm-mobile-custom-link'));
    return row;
  }

  const details = document.createElement('details');
  details.className = 'blm-mobile-custom-group';

  const summary = document.createElement('summary');
  summary.className = 'blm-mobile-custom-summary focus-inset';

  const title = document.createElement('span');
  title.textContent = group.title;

  const symbol = document.createElement('span');
  symbol.className = 'blm-mobile-custom-symbol';
  symbol.setAttribute('aria-hidden', 'true');
  symbol.textContent = '+';

  summary.append(title, symbol);

  const list = document.createElement('ul');
  list.className = 'blm-mobile-custom-submenu list-unstyled';
  list.setAttribute('role', 'list');

  group.items.forEach(([label, url]) => {
    const item = document.createElement('li');
    item.append(createLink(label, url, 'blm-mobile-custom-sublink'));
    list.append(item);
  });

  details.append(summary, list);
  details.addEventListener('toggle', () => {
    symbol.textContent = details.open ? '−' : '+';
  });
  return details;
}

function createAccountLink() {
  const link = document.createElement('a');
  link.href = '/account';
  link.className = 'blm-mobile-account-link focus-inset';
  link.setAttribute('aria-label', 'Account');
  link.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="3.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M4.75 20c.55-4.1 3.15-6.15 7.25-6.15S18.7 15.9 19.25 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg><span>Account</span>';
  return link;
}

function resetProductGalleries(root) {
  root.querySelectorAll('.menu-drawer__featured-content-list-item--product slideshow-component').forEach((slideshow) => {
    const scroller = slideshow.querySelector('[ref="scroller"]');
    if (scroller) scroller.scrollLeft = 0;
    if (typeof slideshow.select === 'function') slideshow.select(0, undefined, { animate: false });
  });
}

function moveFeaturedProducts(drawer) {
  let rail = drawer.querySelector(':scope > .blm-mobile-menu-products');
  if (!rail) {
    rail = [...drawer.querySelectorAll('.menu-drawer__featured-content')].find((element) =>
      element.querySelector('.menu-drawer__featured-content-list-item--product')
    );
  }
  if (!(rail instanceof HTMLElement)) return;

  rail.classList.remove('menu-drawer__featured-content--childlist');
  rail.classList.add('blm-mobile-menu-products');
  if (!rail.querySelector('.blm-mobile-menu-products__title')) {
    const heading = document.createElement('h2');
    heading.className = 'blm-mobile-menu-products__title';
    heading.textContent = 'Featured pieces';
    rail.prepend(heading);
  }
  drawer.append(rail);
  resetProductGalleries(rail);
}

function buildCustomNavigation(details) {
  if (!mobileDrawerMedia.matches) return;

  const drawer = details.querySelector(':scope > .menu-drawer');
  if (!(drawer instanceof HTMLElement)) return;

  const originalNavigation = drawer.querySelector(':scope > .menu-drawer__navigation');
  originalNavigation?.classList.add('blm-mobile-original-navigation');

  let custom = drawer.querySelector(':scope > .blm-mobile-custom-shell');
  if (!custom) {
    custom = document.createElement('div');
    custom.className = 'blm-mobile-custom-shell';

    const nav = document.createElement('nav');
    nav.className = 'blm-mobile-custom-nav';
    nav.setAttribute('aria-label', 'Mobile navigation');
    mobileMenu.forEach((group) => nav.append(createMenuGroup(group)));

    const service = document.createElement('nav');
    service.className = 'blm-mobile-service-nav';
    service.setAttribute('aria-label', 'Customer service');
    serviceMenu.forEach(([label, url]) => {
      service.append(createLink(label, url, 'blm-mobile-service-link'));
    });
    serviceMenuIconLinks.forEach(([label, url, iconSvg]) => {
      service.append(createIconLink(label, url, iconSvg, 'blm-mobile-service-link blm-mobile-service-link--icon'));
    });

    custom.append(nav, service);

    const editorial = drawer.querySelector(':scope > .blm-native-mobile-editorial');
    if (editorial) editorial.insertAdjacentElement('afterend', custom);
    else drawer.prepend(custom);
  }

  let dock = drawer.querySelector(':scope > .blm-mobile-bottom-dock');
  if (!dock) {
    dock = document.createElement('div');
    dock.className = 'blm-mobile-bottom-dock';
    dock.append(createAccountLink());

    const currencySlot = document.createElement('div');
    currencySlot.className = 'blm-mobile-currency-slot';
    const utilities = drawer.querySelector(':scope > .menu-drawer__utility-links');
    if (utilities) currencySlot.append(utilities);
    else {
      const fallback = document.createElement('span');
      fallback.className = 'blm-mobile-currency-fallback';
      fallback.textContent = 'Currency';
      currencySlot.append(fallback);
    }
    dock.append(currencySlot);
    drawer.append(dock);
  }

  moveFeaturedProducts(drawer);
}

function initialize(details) {
  if (!(details instanceof HTMLDetailsElement)) return;

  if (details.dataset.blmCustomMobileMenu !== 'true') {
    details.dataset.blmCustomMobileMenu = 'true';
    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        buildCustomNavigation(details);
      });
    };

    new MutationObserver(schedule).observe(details, { childList: true, subtree: true });
    details.addEventListener('toggle', schedule);
    details.querySelector(':scope > summary')?.addEventListener('pointerdown', schedule, { capture: true });
  }

  buildCustomNavigation(details);
}

function initializeAll(root = document) {
  installMobileMenuStyles();
  root.querySelectorAll('header-drawer > details.menu-drawer-container').forEach(initialize);
}

initializeAll();
document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
mobileDrawerMedia.addEventListener?.('change', () => initializeAll());
